import React from 'react';
import Link from 'gatsby-link';
import { Button, Card, CardText, Grid, Cell } from 'react-md';
import BusinessModelingSplash from '../components/BusinessModelingSplash';

import FootnoteIcon from '../components/FootnoteIcon';
import FootnotesList from '../components/FootnotesList';
import TableOfContents from '../components/TableOfContents';

import BusinessModelCanvasImg from '../img/the-business-model-canvas.png';

const WorkingWithLawyersPage = () => {
	const footnotes = [];

	return (
		<div className="content">
			<BusinessModelingSplash />
			<Card className="md-block-centered main-content-card">
				<CardText>
					<Grid>
						<Cell size={8} style={{ margin: 'auto' }}>
							<TableOfContents
								contents={[
									'Business Model Canvas',
									'Business Model Questionnaire',
									'Training Videos',
									'Helping Your Lawyers Help You'
								]}
							/>
							<h1>Using the Lean Startup methodology</h1>
							<h2 id="business-model-canvas" className="anchor-ref">
								Business Model Canvas
							</h2>
							<p>
								Map out your business and pivot after getting feedback. Find out early, cheaply, and
								safely if your business needs to go in a different direction.
							</p>
							<img src={BusinessModelCanvasImg} style={{ width: '100%' }} />
							<p>
								For an editable, electronic version of the Business Model Canvas on Google Drawings,{' '}
								<a
									href="https://docs.google.com/drawings/d/102mOZQmMxs0CslmNsPZ5KCNQwAIh9rh4baYgT0VWNAA/edit"
									target="_blank"
									rel="noopener noreferrer"
								>
									click here
								</a>.
							</p>
							<p>
								For a downloadable PDF,{' '}
								<a
									href="https://drive.google.com/file/d/0B3EPRVDJnG2BRVF1bjRoR2lrdlE/view?usp=sharing"
									target="_blank"
									rel="noopener noreferrer"
								>
									click here
								</a>.
							</p>
							<h2 id="training-videos" className="anchor-ref">
								Training Videos
							</h2>
							<p>
								For in-depth video explanations of each of the cells in the Business Model Canvas, along
								with real-world examples, visit{' '}
								<a
									href="https://venturewell.org/i-corps/llpvideos/"
									target="_blank"
									rel="noopener noreferrer"
								>
									VentureWell
								</a>.
							</p>
							<h2 id="helping-your-lawyers-help-you" className="anchor-ref">
								Helping Your Lawyers Help You
							</h2>
							<p>
								Mapping out your venture using the Business Model Canvas results in a blueprint that
								lays out the key components that drive your business forward. As such, the Canvas is
								incredibly helpful for when you're talking with your attorney about the legal needs of
								your business.
							</p>
							<p>
								For example, if one of your key activities is providing consulting services to
								customers, then you'll need to make sure to draft a Service Agreement spelling out the
								terms of the engagement. Additionally, if one of your primary sales channels to get
								consulting clients is your company's website, you'll likely need a Terms of Use and a
								Privacy Policy to govern the interaction between your website and visitors who come
								across your site. Showing your attorney your business model canvas will help them spot
								issues and guide you toward your goals.
							</p>
							<h2 id="business-model-questionnaire" className="anchor-ref">
								Business Model Questionnaire
							</h2>
							<p>
								<a
									href="https://drive.google.com/file/d/0B3EPRVDJnG2BZW9FdGxMRUdDS0k/view?usp=sharing"
									target="_blank"
									rel="noopener noreferrer"
								>
									Click here
								</a>{' '}
								for a questionnaire that you can fill out pertaining to your venture that will help
								inform your professional advisors (like your lawyers) about your business.{' '}
								<b>
									Please note that submitting this questionnaire does not create an attorney-client
									relationship between you and the Clinic.
								</b>
							</p>
						</Cell>
					</Grid>
				</CardText>
			</Card>
		</div>
	);
};

export default WorkingWithLawyersPage;



// WEBPACK FOOTER //
// ./src/pages/business-modeling.js